<template>
	<modal-dialog
		:modal-visible="visible"
		:title="title"
		button-class="btn-primary"
		confirm-button-text="<i class='fa fa-paper-plane'></i> &nbsp; Send"
		modal-size="modal-lg"
		:working="working"
		v-on:confirm="createThread"
		v-on:closeModal="closeModal">

		<template v-if="!isSupportThread">
			<field
				v-if="!jobType" 
				label="Assign to Project/Service" 
				col-class="col-md-4" 
				v-model="assignToJob" 
				:params="{type:'boolean'}">	
			</field>

			<div v-if="assignToJob && !jobType">
				<form-group v-if="!service_id" label="Project" col-class="col-md-4">
					<job-picker
						:hide-label="true"
						v-model="job_id"
						job-type="project"
						key="project"
						v-on:change="jobChanged">
					</job-picker>

					<div v-if="job_id > 0 && relevantUsers.length > 0">
						<h5 style="margin-top: 10px;margin-bottom: 10px">Employees associated with this project:</h5>

						<div class="row">
							<label class="col-6" v-for="user in relevantUsers" v-if="user.id != $store.userDetails.id">
								<input type="checkbox" v-model="recipients" :id="user.id" :value="user.id">
								{{ user.first_name }} {{ user.last_name }}
							</label>
						</div>

					</div>

				</form-group>

				<form-group v-if="!job_id" label="Service" col-class="col-md-4">
					<job-picker
						:hide-label="true"
						v-model="service_id"
						job-type="service"
						key="service"
						v-on:change="jobChanged">
					</job-picker>

					<div v-if="service_id > 0 && relevantUsers.length > 0">
						<h5 style="margin-top: 10px;margin-bottom: 10px">Employees associated with this service:</h5>

						<div class="row">
							<label class="col-6" v-for="user in relevantUsers" v-if="user.id != $store.userDetails.id">
								<input type="checkbox" v-model="recipients" :id="user.id" :value="user.id">
								{{ user.first_name }} {{ user.last_name }}
							</label>
						</div>

					</div>

				</form-group>

			</div>
			<div v-else>
				<div v-if="jobId > 0 && relevantUsers.length > 0">
					<h5 style="margin-top: 10px;margin-bottom: 10px">Employees associated with {{jobType}}:</h5>

					<div class="row">
						<label class="col-6" v-for="user in relevantUsers" v-if="user.id != $store.userDetails.id">
							<input type="checkbox" v-model="recipients" :id="user.id" :value="user.id">
							{{ user.first_name }} {{ user.last_name }}
						</label>
					</div>

				</div>
			</div>

			<form-group label="Recipients" col-class="stacked">
				<div class="d-flex flex-row align-items-center">
					<field style="flex-grow: 1;margin-right: 10px;" :params="{type:'select-multi',options:recipientOptions,closeOnSelect:false}" v-model="recipients"></field>

					<div>
						<button v-on:click="addAllToThread" type="button" class="btn btn-success btn-sm" style="margin-top: -3px;">
							<i class="fa fa-check-square"></i>
							Add All
						</button>
						<button v-on:click="removeAllFromThread" type="button" class="btn btn-light btn-sm" style="margin-top: -3px;">
							<i class="fa fa-square"></i>
							Remove All
						</button>
					</div>
				</div>
			</form-group>
			
		</template>

		<field label="Subject" col-class="stacked" v-model="subject" :params="{required:true}"></field>

		<div class="d-flex flex-row align-items-center" v-if="service_id > 0 || job_id > 0">
			<field 
				v-model="is_open_thread"
				:params="{type:'btn-group',buttons:[
					{text: 'Private Thread',value:'0'},
					{text: 'Open Thread',value:'1'}
				]}">
			</field>
			<div class="text-muted thread-access-info" v-if="is_open_thread">This thread will be visible to everyone who has access to this job.</div>
			<div class="text-muted thread-access-info" v-else>This thread will be private, only visible to the direct members</div>
		</div>

		<div v-if="isSupportThread" class="text-muted">
			Please describe the problem as accurately as you can. Be sure to include any error messages that you received.
		</div>

		<field label="Message" col-class="stacked" v-model="message" :params="{type:'textarea',size:'xlg',required:true}"></field>

		<upload-field-with-panel
			api-model="LibraryUpload"
			upload-type="file"
			v-model="uploadImage"
			v-on:uploaded="fileUploaded"
			v-on:deleted="image_id = null">
		</upload-field-with-panel>

		<div v-if="isSupportThread" class="text-muted">
			This will send a chat message to {{$store.appName}} support personnel. Someone will get back to your shortly.
		</div>

	</modal-dialog>
</template>

<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
import FormGroup from "../FormGroup"
import UploadFieldWithPanel from "@/components/super_components/UploadFieldWithPanel"
import JobPicker from "@/components/super_components/JobPicker"


export default {
	name: "NewMessageThread",
	components: {
		ModalDialog,
		Field,
		FormGroup,
		UploadFieldWithPanel,
		JobPicker
	},
	props: ["copiedThread","visible","jobType","jobId","recipientIds","externalUsers","isSupportThread"],
	data() {
		return {
			assignToJob: false,
			job_id: 0,
			service_id: 0,
			subject: "",
			message: "",
			is_open_thread: 1,
			recipients: [],
			relevantUsers: [],
			working: false,
			uploadImage: null,
			image_id: null,
			services: [],
			projects: []
		}
	},
	computed: {
		title() {
			if (this.isSupportThread)
				return "Ask for help from "+this.$store.appName+" support personnel"

			if (this.jobType) {
				return "Create New Thread for #"+this.$store[this.jobType].job_num
			}
			else
				return "Create New Thread"
		},
		recipientOptions() {
			let list = [] 

			if (this.$store.users)
				list = this.$store.users

			if (this.externalUsers) 
				list = list.concat(this.externalUsers)

			if (this.externalUsers) {
				this.externalUsers.forEach(user => {
					if (!list.find(listUser => listUser.id == user.id))
						list.push(user)
				})
			}

			return this.optionify(list.map(user => {
				user.fullName = user.first_name+" "+user.last_name

				return user
			}).filter(user => user.id != this.$store.userDetails.id),"fullName")
		}
	},
	methods: {
		closeModal() {
			this.$emit("closeModal")
		},
		addAllToThread() {

			this.recipients = this.userOptions().map(user => {
				return user.value
			})

		},
		jobChanged() {
			let vm = this
			this.$nextTick(() => {
				if (vm.job_id != 0 || vm.service_id != 0) {

					let model, id, field
					if (vm.job_id > 0) {
						field = 'job_id'
						model = "Job"
						id = vm.job_id
					}
					else {
						field = "service_id"
						id = vm.service_id
						model = "Service"
					}	

					let timeLogFilters = [[field,id]]

					let includes = [{
						model:"User",
						fields: ["id","slug","first_name","last_name"],
						include: [{
							model:"UserPermission",
							fields: ["id","is_inactive"]
						}]
					}]

					let promises = [
						this.getJSON("TimeLog/get",{filters: timeLogFilters,include:includes}),
						this.getJSON(model+"/find/"+id,{include: includes})
					]

					Promise.all(promises).then(responses => {

						let relevantUserList = []

						if (responses[0].success) {

							responses[0].data.forEach(log => {
								//check relevant user list if they're on here already
								let add = true
								relevantUserList.forEach(relUser => {
									if (relUser.id == log.User.id)
										add = false
								})

								if (add)
									relevantUserList.push(log.User)
							})
						}

						if (responses[1].success && responses[1].data.User) 
							relevantUserList = relevantUserList.concat(responses[1].data.User)

						//filter out former employees
						let relevantUsers = relevantUserList.filter(user => {
							if (user.UserPermission.length > 0 && user.UserPermission[0].is_inactive == 1)
								return false

							return true;
						})

						//remove duplicates
						let relevantDuplicatesRemoved = []
						relevantUsers.forEach(user => {
							if (!relevantDuplicatesRemoved.find(added => added.id == user.id))
								relevantDuplicatesRemoved.push(user)
						})

						console.log(relevantUsers)

						vm.relevantUsers = relevantDuplicatesRemoved
					})
					
				}
			})
		},
		removeAllFromThread() {
			this.recipients = []
		},
		fileUploaded(response) {
			this.image_id = response.data.id
		},
		createThread() {
			let vm = this

			let members = []
			let job_id = this.job_id
			let service_id = this.service_id

			if (!this.assignToJob) {
				job_id = 0
				service_id = 0
			}

			members = this.recipients
			members.push(this.$store.userDetails.id)

			this.working = true

			let threadPayload = {
				created_by: this.$store.userDetails.id,
				job_id: job_id,
				service_id: service_id,
				subject: this.subject,
				is_open_thread: this.is_open_thread,
				Members: members
			}	

			if (this.isSupportThread) {
				threadPayload.Members = [64,41,this.$store.userDetails.id]//Mike is 64, Jay is 41
				threadPayload.is_help_chat = 1
			}

			this.saveRecord('MessageThread',threadPayload,response => {

				if (response.success) {

					let messagePayload = {
						thread_id: response.record_id,
						message: vm.message
					}

					if (vm.image_id)
						messagePayload.image_id = vm.image_id

					vm.saveRecord("Message",messagePayload,messageResponse => {
						if (messageResponse.success) {
							vm.working = false

							vm.$emit("newThreadCreated")
							vm.$bus.$emit("newThreadCreated")
						}
					})
				}
			})
		},
		copyInThread() {
			let recipients = []

			let subject = ""

			if (Array.isArray(this.copiedThread.Members)) {
				recipients = this.copiedThread.Members.map(user => {
					return user.id
				})

				subject = this.copiedThread.subject
			}

			this.assignToJob= false
			this.job_id= 0
			this.service_id = 0
			this.subject= subject
			this.message= ""
			this.recipients= recipients

			if (this.jobType) {

				this.assignToJob = true
				
				if (this.jobType == "project") {
					this.job_id = this.jobId
					this.service_id = 0

				}
				else if (this.jobType == "service") {
					this.job_id = 0
					this.service_id = this.jobId
				}

				let relevantUsers = this.$store[this.jobType].User

				console.log(relevantUsers)

				//remove duplicates
				let relevantDuplicatesRemoved = []
				relevantUsers.forEach(user => {
					if (!relevantDuplicatesRemoved.find(added => added.id == user.id))
						relevantDuplicatesRemoved.push(user)
				})

				this.relevantUsers = relevantDuplicatesRemoved
			}
		},
		fetchData() {
			let vm = this

			let userFilters = [
				["invite_accepted",1]
			]

			if (this.recipientIds) {
				this.recipientIds.forEach(id => {
					userFilters.push(["id",id,"or"])
				})

				vm.recipients = vm.recipientIds
			}

			let promises = [
				this.fetchUsers(userFilters,false,["id","slug","first_name","last_name","email","last_active","image_id","invite_accepted"]),
			]

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)

			})
		}
	},
	watch: {
		copiedThread() {
			this.copyInThread()
		},
		visible() {
			this.copyInThread()

			if (this.$store.users.length == 0)
				this.fetchData()

			if (this.recipientIds) 
				this.recipients = this.recipientIds

			this.image_id = null
			this.uploadImage = null

			this.fetchData()
		},
		'$store.users'() {
			if (this.recipientIds && this.recipients.length == 0) 
				this.recipients = this.recipientIds
		},
		recipientIds() {
			if (!this.recipientIds)
				this.recipients = []

			this.fetchData()

			this.recipients = this.recipientIds
		}
	},
	created() {
		if (this.copiedThread) {
			this.copyInThread()
		}
		if (this.visible)
			this.fetchData()
	}
}

</script>

<style type="text/css" scoped>
	.thread-access-info {
		margin-left: 10px;
	}
</style>